import enModal from '../en/modal';

const modal = { ...enModal, ...{
    'modal.header.login': '登入',

    'modal.button.login': '登入',
}};

export default modal;
